import { useEffect } from "react";

export default function useTeacherListEscapeHandler({
  formData,
  isEditModalOpen,
  isMinutesModalOpen,
  minuteFormData,
  openConfirm,
  setIsEditModalOpen,
  setIsMinutesModalOpen,
  setViewingLog,
  setViewingMinute,
  setViewingTeacher,
  onCloseViewingTeacher,
  viewingLog,
  viewingMinute,
  viewingTeacher,
}) {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key !== "Escape") return;

      if (isEditModalOpen) {
        const isDirty = formData.name || formData.charge || formData.phone || formData.birth || formData.address || formData.notes;
        if (isDirty) {
          openConfirm("작성 취소", "작성 중인 내용이 있습니다. 정말 닫으시겠습니까?", () => {
            setIsEditModalOpen(false);
          });
        } else {
          setIsEditModalOpen(false);
        }
        return;
      }

      if (isMinutesModalOpen) {
        const isDirty = minuteFormData.title || minuteFormData.content || minuteFormData.attendees;
        if (isDirty) {
          openConfirm("작성 취소", "작성 중인 내용이 있습니다. 정말 닫으시겠습니까?", () => {
            setIsMinutesModalOpen(false);
          });
        } else {
          setIsMinutesModalOpen(false);
        }
        return;
      }

      if (viewingTeacher) {
        if (onCloseViewingTeacher) onCloseViewingTeacher();
        else setViewingTeacher(null);
        return;
      }
      if (viewingLog) {
        setViewingLog(null);
        return;
      }
      if (viewingMinute) {
        setViewingMinute(null);
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [
    formData,
    isEditModalOpen,
    isMinutesModalOpen,
    minuteFormData,
    openConfirm,
    setIsEditModalOpen,
    setIsMinutesModalOpen,
    setViewingLog,
    setViewingMinute,
    setViewingTeacher,
    onCloseViewingTeacher,
    viewingLog,
    viewingMinute,
    viewingTeacher,
  ]);
}
